import styled from '@emotion/styled';
import { isEmpty } from 'lodash';
import { Col, Form, Input, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CARTNER_CONVOS } from '../../../../constants/define/translation';
import { appStyles, defaultImage, formScrolling, selectSelector } from '../../../../styles';
import { SpinLoading } from '../../../atoms';
import { PreviewCartnerConvos } from '../../../molecules/preview/common/PreviewCartnerConvos';
import { SummaryQuestionRecord } from '../../../../repository/mytm/home/cartnerConvosRepository';
import { ShowImage } from '../../../molecules/upload/ShowImage';

interface FormSummaryConvosProps {
  record?: SummaryQuestionRecord;
}

export const FormSummaryConvos = (props: FormSummaryConvosProps) => {
  const { t } = useTranslation(CARTNER_CONVOS);
  const { record } = props;
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const defaultValue = {
    title: record?.title,
  };

  const getRespondents = countValue => {
    if (countValue && countValue === 1) {
      return `1 respondent`;
    }
    return `${countValue} respondents`;
  };

  return (
    <>
      <SpinLoading absolute>
        <SwitchContainer>
          <Form name="form-CartnerConvos" form={form} initialValues={defaultValue} layout="vertical">
            <Row className="form-CartnerConvos-container" gutter={[24, 24]}>
              <StyledSummaryCartnerConvos span={16}>
                <Row gutter={[16, 16]}>
                  <Col span={24} className="position-relative">
                    <Form.Item name="title" label={t('form.title')}>
                      <TextArea rows={3} value="anh le" disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <div className="header">{t('form.result')}</div>
                  </Col>
                  <Col span={24} className="poll-container">
                    {!isEmpty(record?.answers) &&
                      record?.answers.map(result => (
                        <div className="poll-result">
                          <div className="result-bar">
                            <div className="percentage">{result?.percent ? Math.round(result.percent) : 0}%</div>
                            <div
                              className={
                                result?.percent && Math.round(result.percent) === 100
                                  ? 'result-text-full'
                                  : 'result-text'
                              }
                            >
                              <div className="answer-title">{result?.answerTitle}</div>
                              <span className="description">{result?.answerDescription}</span>
                            </div>
                            <div
                              className={
                                result?.percent && Math.round(result.percent) === 100
                                  ? 'bar-filled border-right'
                                  : 'bar-filled'
                              }
                              style={{ width: `${result?.percent || 0}%` }}
                            />
                          </div>
                          <div className="respondents">{getRespondents(result?.count || 0)}</div>
                        </div>
                      ))}
                  </Col>
                  <Col span={24}>
                    <div className="total-respondents">Total: {getRespondents(record?.totalAnswer || 0)}</div>
                  </Col>
                </Row>
              </StyledSummaryCartnerConvos>
              <StyledSelectImageCol span={8}>
                <ShowImage
                  {...{
                    nodePreview: (
                      <PreviewCartnerConvos
                        values={{
                          backgroundImage: record?.imageUrl,
                          describeText: t('form.defaultImage'),
                        }}
                        isPreview
                        className={record?.imageUrl ? '' : 'preview-cartner-convos'}
                        height="400px"
                      />
                    ),
                  }}
                />
              </StyledSelectImageCol>
            </Row>
          </Form>
        </SwitchContainer>
      </SpinLoading>
    </>
  );
};

const SwitchContainer = styled.div`
  & .ant-form-item-label {
    font-weight: bold;
    font-size: 15px;
  }

  & .form-CartnerConvos-container {
    padding: 0 1.5rem 1.5rem 1.5rem;

    .form-CartnerConvos {
      resize: none;
    }

    .count-item {
      position: absolute;
      right: 15px;
      top: 42px;
      font-size: 11px;
      color: #cbcbcb;
    }

    .count-item-title {
      position: absolute;
      left: 25px;
      top: 103px;
      font-size: 11px;
      color: #cbcbcb;
    }

    .position-relative {
      position: relative;
    }

    input {
      padding-right: 40px;
    }
    .header {
      font-size: 14px;
      font-weight: bold;
    }

    .poll-result {
      margin-bottom: 8px;
      display: flex;
    }

    .result-bar {
      display: flex;
      align-items: center;
      position: relative;
      width: 60%;
      gap: 8px;
      min-height: 50px;
      background-color: #fff;
      border-radius: 16px;
      backdrop-filter: blur(7px);
      border: 1px solid #d9d9d9;
      box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.15);
    }

    .bar-filled {
      position: absolute;
      left: 0;
      background-color: #c4c4c4;
      height: 100%;
      border-radius: 15px 0 0 15px;
    }

    .border-right {
      border-radius: 15px;
    }

    .percentage {
      position: absolute;
      left: 15px;
      font-weight: 400;
      z-index: 1;
      color: #03a800;
      font-size: 24px;
    }

    .result-text {
      margin-left: 70px;
      padding: 6px 0;
      width: 80%;
      z-index: 2;
    }
    .result-text-full {
      margin-left: 85px;
      padding: 10px 0;
      width: 75%;
      z-index: 2;
    }
    .answer-title {
      display: block;
      font-size: 12px;
      font-weight: bold;
      color: #000;
      margin-bottom: -2px;
    }

    .description {
      font-size: 12px;
      font-weight: 400;
      color: #000;
    }

    .respondents {
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      color: #000;
      text-align: right;
      margin-left: 20px;
    }
    .total-respondents {
      font-weight: 400;
      font-size: 14px;
      margin-top: -10px;
    }
  }

  & .preview-home-product {
    border-radius: 18px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }
`;

const StyledSelectImageCol = styled(Col)`
  padding: 0px !important;
  min-height: 400px;
  height: 470px;
  background-color: #fff;
  position: relative;
  ${defaultImage}

  & .preview-cartner-convos {
    background-color: #fff;
  }
`;

const StyledSummaryCartnerConvos = styled(Col)`
  padding-top: 1rem;
  ${formScrolling}
  ${selectSelector}

  & input[type='text'],
  & input[type='number'] {
    ${appStyles.inputStyle}
  }

  & .add-partner {
    float: right;
    color: #3490ff;
    font-weight: bold;
    font-size: 14px;
    position: absolute;
    right: 0;
    z-index: 9999;
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    display: inline;
  }

  & .ant-form-item-label {
    font-weight: bold;
    font-size: 16px;
  }

  & button.btn-submit-form-home {
    ${appStyles.commonButtonSubmitted}
  }

  & .ant-form-item {
    margin-bottom: 0.5rem;
  }

  & .ant-picker {
    width: 100%;
    padding: 0;
    ${appStyles.commonBorderRadius}
    & input {
      padding: 4px 0 4px 12px;
    }
    & .ant-picker-suffix {
      font-size: 20px;
      ${appStyles.background.black}
      ${appStyles.color.white}
      padding: 8px;
    }
  }

  & textarea {
    ${appStyles.commonBorderRadius}
  }

  & .ant-input-affix-wrapper {
    padding: 0 11px;
    ${appStyles.commonBorderRadius}
  }

  & .ant-form-item {
    ${appStyles.commonItemMarginBottom}
  }

  & .ant-form-item-explain {
    margin: 0;
  }

  & .ant-picker-clear {
    right: 40px;
  }

  & .ant-descriptions {
    cursor: default;
    & .ant-descriptions-header {
      margin-bottom: 5px;
    }
  }

  & .ant-upload-span {
    display: none !important;
  }

  & .popover {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 10%;
  }

  & .popoverSub {
    position: absolute;
    z-index: 2;
    bottom: 0;
    right: 0;
  }

  & .cover {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  & .sketch-picker {
    cursor: pointer;
  }
`;
